import React from "react";
import { postRequest } from "./QuoteApiService";

export const getItemsSearchCount = (rec) => {
  return new Promise((resolve, reject) => {
    try {
      // do an SDK, DB call or API endpoint axios call here and return the promise.
      postRequest('GetItemsSearchCount/', rec)
      .then((res) => {
        console.log("GetItemsSearchCount > axios res=", res);
        //const persons = res.data;
        resolve(res.data);
      })
      .catch((err) => {
        console.log("GetItemsSearchCount > axios err=", err);
        reject("Error in GetItemsSearchCount axios!");
      });
    } catch (error) {
      console.error("in services > GetItemsSearchCount, Err===", error);
      //reject(SYSTEM_ERROR);
    }
  });
  
}